import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-success',
    template: `
    <div class="alert alert-success" role="alert">
      <div [ngSwitch]="workflow_name">
        <p *ngSwitchCase="'outbound'">The submission has been successfully sent. You may close this window to continue.</p>
        <p *ngSwitchCase="'input1'">The file has been successfully created. Refresh the database connections to make the most recent versions visible. You may close this window to continue.</p>
        <p *ngSwitchDefault>The indication has been successfully imported. Refresh the database connections to make the most recent versions visible. You may close this window to continue.</p>
      </div>
    </div>`,
    styles: [``],
    standalone: false
})
export class AimSuccessComponent implements OnInit {
  public workflow_name;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const routeData = this.route.snapshot;
    this.workflow_name = routeData.queryParamMap.get('workflow_name')?.toLowerCase();
  }
}
